import React from 'react';
import TreatmentPageTemplate from './TreatmentPageTemplate';

const KneeJointPainPage = () => {
  const treatmentData = {
    title: "Knee Joint Pain",
    description: "Knee joint pain can make everyday activities difficult, whether it's caused by injury, arthritis, or overuse. This common complaint affects people of all ages and can limit mobility and independence. Natural therapies can help reduce pain, improve flexibility, and support joint health for lasting relief.",
    causes: [
      "Arthritis (osteoarthritis, rheumatoid arthritis)",
      "Injury or overuse",
      "Aging",
      "Inflammation",
      "Obesity"
    ],
    symptoms: [
      "Pain or swelling in the knee",
      "Stiffness or reduced range of motion",
      "Clicking or popping sounds",
      "Weakness or instability",
      "Difficulty walking"
    ],
    approach: "We use anti-inflammatory herbs, soothing oils, and gentle therapies to reduce pain and swelling, restore mobility, and support long-term knee health. Each plan is tailored to your needs for safe, effective relief.",
    benefits: [
      "Reduces pain and inflammation",
      "Improves knee flexibility",
      "No harsh side effects",
      "Personalized, gentle care"
    ],
    lifestyleRecommendations: [
      "Maintain a healthy weight",
      "Practice regular, gentle exercise",
      "Use supportive footwear",
      "Avoid high-impact activities"
    ],
    faqs: [
      {
        question: "Can herbal treatment help with chronic knee pain?",
        answer: "Yes, our approach is effective for both acute and chronic cases."
      },
      {
        question: "Is this safe for seniors?",
        answer: "Absolutely, our therapies are gentle and suitable for all ages."
      },
      {
        question: "How soon will I feel relief?",
        answer: "Many patients notice improvement within a few sessions."
      }
    ]
  };

  return <TreatmentPageTemplate {...treatmentData} />;
};

export default KneeJointPainPage; 